import React, { useState, useRef, useEffect } from "react";
import { Link, Navigate } from "react-router-dom";
import pdf from './../uploads/sample.pdf'
import Header from "../templates/Header/Header";
const Help = () => {
 
// need to create style sheet and add display:none to the button
  return (
    <>
      <div className="mx-auto h-full w-full">
        <div className="main-section">
          <Header />
          <main>
            <div className="mx-auto h-full w-full">
              <div id="presentServices" className="px-7 py-4">
              <header className="flex">
                  {/* <p>Operations | Creative Communication</p>
                  <h1>{usrData.divisionName}</h1> */}
                   <div className="breadcrumb"><h2 className="ml-0 text-[16px] text-[#033d9b] tracking-[1px] font-extrabold uppercase"> <Link to='/dashboard'>Dashboard</Link> / Help</h2></div>
                </header>
                <br/>
                <main>
                 <iframe src={pdf+'#toolbar=0'} frameborder="0" width="100%" height="100%"></iframe>
                </main>
              </div>
            </div>
        
          </main>
        </div>
      </div>


    </>
  );

}
export default Help;

